import queryBuilder from './query-builder';
import {appConfig} from '@stencil/hotels-config';

const {defaultPartner} = appConfig;
const getCgReviewPageUrl = (queryData, partner = defaultPartner) => {
  const queryStringForReviewUrl = queryBuilder(queryData);
  return `/${partner}/nhotel-booking/${queryStringForReviewUrl}`;
};

export default getCgReviewPageUrl;
